<template>
  <b-modal
    :id="modalId"
    modal-class="ts-auth-modal ts-login-modal"
    dialog-class="modal-dialog-centered"
    header-class="border-0 p-4 pb-0 mb-3"
    body-class="px-4 pb-4 pt-0"
    hide-footer
    :aria-labelledby="`${modalId}-title`"
    @show="resetState"
  >
    <template #modal-header="{ close }">
      <h2 :id="`${modalId}-title`" class="modal-title ts-auth-title fw-bold">{{ modalTitle }}</h2>
      <button class="btn-close" type="button" :aria-label="closeLabel" @click="close()"></button>
    </template>

    <form novalidate @submit.prevent="onRecover">
      <p class="small mb-3">{{ translations[14409] }}</p>
      <div v-if="isRecoverErrors" class="alert alert-danger" role="alert">{{ translations[11849] }}</div>
      <div v-if="isRecoverSuccess" class="alert alert-success" role="status">{{ translations[11850] }}</div>

      <label class="visually-hidden" :for="`${modalId}-email`">{{ translations[5549] }}</label>
      <input
        :id="`${modalId}-email`"
        v-model.trim="recover.email"
        class="form-control"
        type="email"
        autocomplete="email"
        :placeholder="translations[5549]"
        required
      />

      <button class="btn btn-primary w-100 fw-bold mt-3" type="submit" :disabled="loading || !recover.email">
        <span v-if="loading" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
        {{ translations[1165] }}
      </button>

      <div class="ts-login-footer text-center small mt-3">
        <span>{{ translations[13733] }}</span>
        {{ ' ' }}<a href="#" @click.prevent="openLogin">{{ translations[13726] }}</a>
      </div>
    </form>
  </b-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { passwordRecovery, passwordRecoveryCompany } from '@/api/Auth';

@Component
export default class ResetPasswordModal extends Vue {
  @Prop({ type: String, required: true }) modalId!: string;

  @Prop({ type: String, default: 'applicant' }) userType!: 'applicant' | 'company';

  get modalTitle() {
    return {
      applicant: this.translations[14436],
      company: this.translations[14437],
    }[this.userType] || '';
  }

  get resetPasswordCallback() {
    return {
      applicant: passwordRecovery,
      company: passwordRecoveryCompany,
    }[this.userType];
  }

  isRecoverSuccess = false;

  isRecoverErrors = false;

  loading = false;

  get closeLabel() {
    return AppModule.translation[2511];
  }

  recover = {
    email: '',
    sid: this.sid,
    lang: this.lang,
  }

  get sid() {
    return AppModule.sid;
  }

  get lang() {
    return AppModule.language;
  }

  get translations() {
    return AppModule.translation;
  }

  resetState() {
    this.isRecoverErrors = false;
    this.isRecoverSuccess = false;
  }

  async onRecover() {
    if (!this.recover.email || this.loading) return;
    this.loading = true;
    this.resetState();
    try {
      await this.resetPasswordCallback({ ...this.recover, sid: this.sid, lang: this.lang });
      this.isRecoverSuccess = true;
      this.recover.email = '';
    } catch (error: any) {
      this.isRecoverErrors = true;
      const message = error?.response?.data?.message;
      if (message) {
        this.$bvToast.toast(message, {
          title: 'Warning',
          variant: 'warning',
          autoHideDelay: 5000,
          solid: true,
        });
      }
    } finally {
      this.loading = false;
    }
  }

  openLogin() {
    this.$bvModal.hide(this.modalId);
    this.$bvModal.show('login-modal');
  }
}
</script>
